import { __rest } from "tslib";
import React from 'react';
import InlineLink from "../../links/InlineLink";
import BaseText from '../BaseText';
// method that returns whether or not the given child has a valid type
const hasValidType = (child) => {
    if (typeof child === 'string') {
        return true;
    }
    if (React.isValidElement(child) && (child.type === InlineLink || child.type === 'br')) {
        return true;
    }
    return false;
};
// method that throws errors at runtime in case there are invalid children
const throwInvalidContentError = (content) => {
    let contentType = typeof content;
    if (React.isValidElement(content)) {
        if (typeof content.type !== 'string') {
            contentType = content.type.name || typeof content.type;
        }
        else {
            contentType = content.type;
        }
    }
    throw new TypeError(`The following content is not allowed inside a BodyText: ${contentType}`);
};
const BodyText = (_a) => {
    var { Tag = 'p', children } = _a, props = __rest(_a, ["Tag", "children"]);
    return (React.createElement(BaseText, Object.assign({ Tag: Tag, size: "default" }, props), React.Children.toArray(children).every((child) => {
        if (hasValidType(child)) {
            return true;
        }
        throwInvalidContentError(child);
        return false;
    }) && children));
};
export default BodyText;
//# sourceMappingURL=BodyText.js.map